export default {
  title: 'Modifiers',
  master_title: 'Merkmodus - Modifiers',
  products_creation_disabled:
    'Vanwege de actieve integratie met {{integration}} is het aanmaken van nieuwe producten niet toegestaan. Breng de wijzigingen aan in {{integration}} en synchroniseer het menu.',
  labels: {
    select_all: 'Alles selecteren',
  },
  buttons: {
    add_modifier: 'Modifier toevoegen',
    delete_selected: 'Geselecteerde verwijderen',
    refresh: 'Vernieuwen',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
  },
};
